import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero, useTitle } from "../components/PageHero";
import { Reveal, Tag } from "../components/Reveal";
import { CTABand } from "../components/CTABand";
import { SOLUTIONS } from "../data/solutions";
import { IMG } from "../data/site";

export default function Solutions() {
  useTitle("Solutions — Fabrication, Wear Protection & Reconditioning | SABAKT Saudi Arabia");
  return (
    <main>
      <PageHero image={IMG.shopfloor} eyebrow="SABAKT Solutions" testid="solutions-hero"
        title="Engineered Solutions for Demanding Operations." accent="Solutions"
        text="From heavy fabrication to wear protection and equipment reconditioning — every solution is specified against your operating conditions, not a catalogue." />
      <section className="py-20 lg:py-28">
        <div className="mx-auto max-w-7xl space-y-8 px-4 sm:px-8 lg:px-16">
          {SOLUTIONS.map((s, i) => (
            <Reveal key={s.slug} delay={0.05}>
              <Link to={`/solutions/${s.slug}`} data-testid={`solutions-row-${s.slug}`}
                className="group grid overflow-hidden border border-seam transition-colors duration-300 hover:border-spark md:grid-cols-[320px_1fr]">
                <div className="aspect-[16/9] overflow-hidden md:aspect-auto md:h-full">
                  <img src={s.image} alt={s.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="flex flex-col justify-between gap-6 bg-iron p-8 lg:p-10">
                  <div>
                    <div className="flex items-center gap-4">
                      <span className="font-display text-4xl font-black text-seam group-hover:text-spark">{String(i + 1).padStart(2, "0")}</span>
                      <Tag>{s.seo.split("·")[0]}</Tag>
                    </div>
                    <h2 className="mt-3 font-display text-3xl font-extrabold uppercase tracking-tight text-frost lg:text-4xl">{s.title}</h2>
                    <p className="mt-3 max-w-2xl text-base leading-relaxed text-cadmium">{s.short}</p>
                  </div>
                  <span className="inline-flex items-center gap-2 font-display text-sm font-bold uppercase tracking-wider text-spark">
                    {s.cta} <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand />
    </main>
  );
}
